export async function wikiPageLookup(pageName) {
	
	// Within this function we will only return false (page does not exist)
	// If we get a "for sure missing"
	// On error or unknown, return true because dunno
	if (!pageName) return null;

	let wikiUrl = 'https://wiki.guildwars2.com/api.php?action=query&prop=revisions&rvprop=content&format=json&titles=';


	// Use encode URI to ensure proper url format
	// No need to sanitize first entry, mediawiki understands as is
	wikiUrl += encodeURI(pageName);

	// Add this due to mediawiki CORS schenanigans and testing on localhost
	wikiUrl += '&origin=*';

	try {
		const res = await fetch(wikiUrl);
		if (res.response > 299 || res.response < 200) return null;

		const wikiRes = await res.json();
		if (wikiRes.Error) return null;
		const pages = Object.keys(wikiRes.query.pages);

		// If a page does not exist, it is keyed with '-1'
		if (pages[0] === '-1') return false;
		else return true;
		
	} catch (e) {
		console.log(`Error occured when performing mediawiki lookup for ${wikiUrl}`);
		console.log(e);
		return true;
	}
};
